import {
    Container,
    Typography,
    Box,
    Stack,
} from "@mui/material";
import React from 'react';
import { useTranslation, Translation } from "react-i18next";
import { getLang } from "../../helper/LangHelper";
import { Carousel } from "react-responsive-carousel";

export default function TestCarousel() {
    const { t } = useTranslation();
    const [value, setValue] = React.useState(1234);

    React.useEffect(() => {
        setValue(1234);
    }, []);

    let lang = getLang();


    const CarouselProps = {
        showThumbs: false,
        autoPlay: true,
        infiniteLoop: true,
        showIndicators: false,
        showStatus: false,
        showArrows: false,
        stopOnHover: true,
        // interval: 60000,
        interval: 6000,
        emulateTouch: true,
    };

    const colorList = [
        "#FF5733",
        "#33C1FF",
        "#28A745",
        "#FFC300",
        "#8E44AD",
        "#E67E22",
    ];

    // setValue(1234);

    return (
        <Container maxWidth="lg">
            <Stack direction="column">
                <Typography variant="h3">Test Simple</Typography>


                <Box>
                    <p>Current Lang: {lang}</p>
                    <p>translateText: {t("testing.msg")}</p>
                    <pre>Value: {value} </pre>
                </Box>
                <Carousel {...CarouselProps} style={{ height: 300, width: "100%" }}>
                    {colorList.map((color, index) => (
                        <Box
                            key={index}
                            sx={{
                                height: 300,
                                backgroundColor: color,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                color: 'white',
                                fontSize: 24,
                                fontWeight: 'bold',
                            }}
                        >
                            Slide {index + 1}
                        </Box>
                    ))}
                </Carousel>
            </Stack>
        </Container>
    )
}
